import { apiClient } from './api'

export type ImportMode = 'projects' | 'tasks'

export interface ImportProblem {
  row: number
  message: string
}

export interface ImportPreview {
  headers: string[]
  row_count: number
  sample: Array<Record<string, string>>
  mode: ImportMode
  fields: string[]
  required: string[]
  suggested_mapping: Record<string, string | null>
  mapping: Record<string, string | null>
  date_order: 'dmy' | 'mdy'
  projects: number
  tasks: number
  errors: ImportProblem[]
  warnings: ImportProblem[]
  error_count: number
  warning_count: number
}

export interface ImportResult extends ImportPreview {
  batch: string
  projects_created: number
  tasks_created: number
  unmatched_people: string[]
}

interface ImportOptions {
  mode?: ImportMode
  mapping?: Record<string, string | null>
  dateOrder?: 'dmy' | 'mdy'
}

function form(file: File, opts: ImportOptions): FormData {
  const fd = new FormData()
  fd.append('file', file)
  if (opts.mode) fd.append('mode', opts.mode)
  if (opts.mapping) fd.append('mapping', JSON.stringify(opts.mapping))
  if (opts.dateOrder) fd.append('date_order', opts.dateOrder)
  return fd
}

/** Spreadsheet (CSV/XLSX) import — backend/app/api/v1/endpoints/spreadsheet_import.py */
export const spreadsheetImportService = {
  async preview(file: File, opts: ImportOptions = {}): Promise<ImportPreview> {
    const { data } = await apiClient.post<ImportPreview>('/api/v1/spreadsheet-import/preview', form(file, opts))
    return data
  },
  async apply(file: File, opts: ImportOptions = {}): Promise<ImportResult> {
    const { data } = await apiClient.post<ImportResult>('/api/v1/spreadsheet-import/apply', form(file, opts))
    return data
  },
  async undo(batch: string): Promise<{ tasks_removed: number; projects_removed: number; projects_kept: number }> {
    const { data } = await apiClient.delete(`/api/v1/spreadsheet-import/${batch}`)
    return data
  },
}
